import * as z from "zod";
import { countryRateTableEntriesOutput } from "./country-rate-table-entries";

export const getDefaultCountryRateTables = {
  name: "getDefaultCountryRateTables" as const,
  input: z.object({}),
  output: countryRateTableEntriesOutput,
};
